import { render } from "./ProfilUserNotEditable.vue?vue&type=template&id=e8f09e64"
import script from "./ProfilUserNotEditable.vue?vue&type=script&lang=js"
export * from "./ProfilUserNotEditable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__